export default __webpack_public_path__ + "static/media/gallery13.c196c156.webp";